import React from 'react';
import { i18n } from '../../services/i18n';
import { relLabelKey } from './ReliabilityBadge';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const W = 520, H = 120, PAD = 14;
const color = (s) => (s == null ? '#9ca3af' : s >= 80 ? '#059669' : s >= 60 ? '#16a34a' : s >= 40 ? '#d97706' : '#dc2626');
const fmt = (iso) => new Date(iso).toLocaleDateString(i18n.locale(), { day: '2-digit', month: '2-digit' });

// Weekly reliability score sparkline (SVG, no dependency) for the partner space
const ReliabilityHistoryChart = ({ history = [] }) => {
  const pts = history.filter((h) => h.score != null);
  if (!pts.length) return <p className="text-xs text-gray-400" data-testid="reliability-history-empty">{i18n.t('ps.histEmpty')}</p>;
  const x = (i) => PAD + (i * (W - 2 * PAD)) / Math.max(1, history.length - 1);
  const y = (s) => H - PAD - (s / 100) * (H - 2 * PAD);
  const path = history.map((h, i) => (h.score == null ? null : `${x(i)},${y(h.score)}`)).filter(Boolean);
  const first = pts[0].score, last = pts[pts.length - 1].score;
  const delta = pts.length > 1 ? last - first : 0;
  const Trend = delta > 0 ? TrendingUp : delta < 0 ? TrendingDown : Minus;
  return (
    <div data-testid="reliability-history">
      <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
        <span>{i18n.t('ps.histTitle', { n: history.length })}</span>
        <span className={`inline-flex items-center gap-1 font-semibold ${delta > 0 ? 'text-emerald-700' : delta < 0 ? 'text-red-700' : 'text-gray-500'}`} data-testid="reliability-history-trend"><Trend size={13} /> {i18n.t('ps.trend', { d: `${delta > 0 ? '+' : ''}${delta}`, since: fmt(pts[0].week_start) })}</span>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto" role="img" aria-label={i18n.t('ps.histTitle', { n: history.length })}>
        {[40, 60, 80].map((g) => <g key={g}><line x1={PAD} x2={W - PAD} y1={y(g)} y2={y(g)} stroke="#e5e7eb" strokeDasharray="3 3" /><text x={W - PAD + 2} y={y(g) + 3} fontSize="8" fill="#9ca3af">{g}</text></g>)}
        <polyline fill="none" stroke="#f97316" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" points={path.join(' ')} />
        {history.map((h, i) => h.score == null ? null : (
          <g key={h.week_start} data-testid={`reliability-history-point-${h.week_start}`}>
            <circle cx={x(i)} cy={y(h.score)} r={h.current ? 5 : 3.5} fill={color(h.score)} stroke="#fff" strokeWidth="1.5" />
            <title>{i18n.t('rel.weekTip', { d: fmt(h.week_start), s: h.score, l: i18n.t(relLabelKey(h.label)), n: h.sample })}</title>
          </g>
        ))}
        {history.map((h, i) => (i % Math.ceil(history.length / 6) === 0 || h.current) && <text key={`l${h.week_start}`} x={x(i)} y={H - 2} fontSize="8" textAnchor="middle" fill="#6b7280">{fmt(h.week_start)}</text>)}
      </svg>
    </div>
  );
};

export default ReliabilityHistoryChart;
